// extracted by mini-css-extract-plugin
module.exports = {"fb-share-section":"FbShareSection-module__fb-share-section___3-WxW","share-button":"FbShareSection-module__share-button___2U_5Y"};